import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/3. Warehousehs.png'

const Warehouses = ({ submissions }: IFoodBanksProps ) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'total_number_of_warehouses')}
            text="Total number of Warehouses"
        />
    );
}

export default Warehouses;